import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseSharedModule } from '@fuse/shared.module';
import { ComponentsModule } from 'app/components/components.module';
import { EntityDashboardComponent } from './entity-dashboard.component';
import { EntityDashboardService } from 'app/shared/services/entity-dashboard.service';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { WidgetModule } from 'app/main/widgets/widget.module';
import { GridsterModule } from 'angular-gridster2';
import { LinkWizardComponent } from './link-wizard/link-wizard.component';
import { SubjectModule } from '../subjects/subject.module';
import { AssessmentDialogComponent } from './assessment-dialog/assessment-dialog.component';
import { TaskNotificationDialogComponent } from './task-notification-dialog/task-notification-dialog.component';

@NgModule({
  declarations: [
    EntityDashboardComponent,
    LinkWizardComponent,
    AssessmentDialogComponent,
    TaskNotificationDialogComponent,
  ],
  imports: [
    MatButtonModule,
    MatProgressBarModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    MatRippleModule,
    MatSidenavModule,
    MatToolbarModule,
    MatDividerModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatSortModule,
    MatTabsModule,
    MatStepperModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    ComponentsModule,
    CommonModule,
    FuseSharedModule,
    PhoenixDirectivesModule,
    WidgetModule,
    GridsterModule,
    SubjectModule,
  ],
  providers: [EntityDashboardService],
  exports: [
    EntityDashboardComponent,
    LinkWizardComponent,
    AssessmentDialogComponent,
    TaskNotificationDialogComponent,
  ],
})
export class EntitiesModule {}
